import { MultiCheckboxFilterOption } from '../types';
import { MultiSelectCheckbox } from '../../components';

export const config: MultiCheckboxFilterOption = {
  id: 'omicsExplorer.filters.clinVarReviewStatus',
  title: {
    id: 'omicsExplorer.filters.clinVarReviewStatus',
    defaultMessage: 'ClinVar Review Status',
  },
  content: MultiSelectCheckbox,
  injectedProps: {
    searchKey: 'clinvarReview',
    checkboxOptions: [
      {
        id: 'omicsExplorer.filters.clinVarReviewStatus.practiceGuideline',
        searchValue: 'practice guideline',
        intlLabel: {
          id: 'omicsExplorer.filters.clinVarReviewStatus.practiceGuideline',
          defaultMessage: 'Practice Guideline',
        },
      },
      {
        id: 'omicsExplorer.filters.clinVarReviewStatus.reviewedByExpertPanel',
        searchValue: 'reviewed by expert panel',
        intlLabel: {
          id: 'omicsExplorer.filters.clinVarReviewStatus.reviewedByExpertPanel',
          defaultMessage: 'Reviewed By Expert Panel',
        },
      },
      {
        id: 'omicsExplorer.filters.clinVarReviewStatus.criteriaProvidedMultipleSubmitters',
        searchValue: 'criteria provided, multiple submitters, no conflicts',
        intlLabel: {
          id: 'omicsExplorer.filters.clinVarReviewStatus.criteriaProvidedMultipleSubmitters',
          defaultMessage:
            'Criteria Provided, Multiple Submitters, No Conflicts',
        },
      },
      {
        id: 'omicsExplorer.filters.clinVarReviewStatus.criteriaProvidedSingle',
        searchValue: 'criteria provided, single submitter',
        intlLabel: {
          id: 'omicsExplorer.filters.clinVarReviewStatus.criteriaProvidedSingle',
          defaultMessage: 'Criteria Provided, Single Submitter',
        },
      },
      {
        id: 'omicsExplorer.filters.clinVarReviewStatus.criteriaProvidedConflicting',
        searchValue: 'criteria provided, conflicting interpretations',
        intlLabel: {
          id: 'omicsExplorer.filters.clinVarReviewStatus.criteriaProvidedConflicting',
          defaultMessage: 'Criteria Provided, Conflicting Interpretations',
        },
      },
      {
        id: 'omicsExplorer.filters.clinVarReviewStatus.noAssertionCriteriaProvided',
        searchValue: 'no assertion criteria provided',
        intlLabel: {
          id: 'omicsExplorer.filters.clinVarReviewStatus.noAssertionCriteriaProvided',
          defaultMessage: 'No Assertion Criteria Provided',
        },
      },
      {
        id: 'omicsExplorer.filters.clinVarReviewStatus.noAssertionProvider',
        searchValue: 'no assertion provided',
        intlLabel: {
          id: 'omicsExplorer.filters.clinVarReviewStatus.noAssertionProvider',
          defaultMessage: 'No Assertion Provided',
        },
      },
      {
        id: 'omicsExplorer.filters.clinVarReviewStatus.noInterpretationForSingleVariant',
        searchValue: 'no interpretation for the single variant',
        intlLabel: {
          id: 'omicsExplorer.filters.clinVarReviewStatus.noInterpretationForSingleVariant',
          defaultMessage: 'No Interpretation for the Single Variant',
        },
      },
    ],
  },
};
